"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[509],{

/***/ 8987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconAlert = function SvgIconAlert(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M11 15h2v2h-2v-2Zm0-8h2v6h-2V7Zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Z",
    fill: "#fff"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgIconAlert);

/***/ }),

/***/ 4106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/common/Typography/index.tsx + 1 modules
var Typography = __webpack_require__(990);
;// CONCATENATED MODULE: ./components/common/Checkbox/Checkbox.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  margin-left: 8px;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  border: 2px solid ",
        ";\n  border-radius: 2px;\n  :focus {\n    outline: none;\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}


const Container = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    componentId: "sc-1fb57a88-0"
})(_templateObject());
const StyledSpan = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-1fb57a88-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.fonts.archivo;
});
const CheckboxInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-1fb57a88-2"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});

;// CONCATENATED MODULE: ./components/common/Checkbox/index.tsx



const Checkbox = (param)=>{
    let { label , checked , onChange , className  } = param;
    const [isChecked, setIsChecked] = (0,react.useState)(checked);
    function handleOnChange(event) {
        const checked = event.target.checked;
        onChange(checked);
        setIsChecked(checked);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInput, {
                type: "checkbox",
                checked: isChecked,
                onChange: handleOnChange
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                type: "span",
                children: label
            })
        ]
    });
};
/* harmony default export */ var common_Checkbox = (Checkbox);


/***/ }),

/***/ 4941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "TO": function() { return /* binding */ TitleAndIconContainer; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "YM": function() { return /* binding */ Backdrop; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "qk": function() { return /* binding */ IconContainer; },
/* harmony export */   "zM": function() { return /* binding */ AlertIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2667);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7236);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: ",
        ";\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-color: ",
        ";\n  backdrop-filter: blur(8px);\n  :focus {\n    outline: none;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: fixed;\n  top: 4rem;\n  left: 4rem;\n  right: 4rem;\n  z-index: ",
        ";\n  height: auto;\n  margin: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  @media screen and (max-width: ",
        ") {\n    top: 1rem;\n    left: 1rem;\n    right: 1rem;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding: 5vh;\n  max-height: 90vh;\n  overflow: hidden;\n  width: ",
        ";\n  max-width: 96%;\n  background-color: ",
        ";\n  border-right: 10px solid transparent;\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  :focus {\n    outline: none;\n  }\n  @media screen and (max-width: ",
        ") {\n  }\n  @media screen and (max-width: ",
        ") {\n    padding: 3vh;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  margin: auto;\n\n  @media screen and (max-width: ",
        ") {\n    width: 570px;\n    max-width: 100%;\n  } ;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding-bottom: 2rem;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 16px;\n  width: 16px;\n  fill: ",
        "\n  :hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  margin-bottom: 64px;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 8px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fill: ",
        "\n  width: 20px;\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}



const Backdrop = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f597b95-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.zIndex.backdrop;
}, (param)=>{
    let { theme  } = param;
    return "".concat((0,polished__WEBPACK_IMPORTED_MODULE_3__/* .rgba */ .m4)(theme.colors.functional.darkestGray, 0.1));
});
const Container = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f597b95-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.zIndex.backdrop + 1;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f597b95-2"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.navBreakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.boxShadow.black;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Content = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f597b95-3"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Header = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f597b95-4"
})(_templateObject4());
const Title = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-5f597b95-5"
})(_templateObject5(), (param)=>{
    let { withMarginBottom  } = param;
    return withMarginBottom && "margin-bottom: 8px;";
});
const CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-5f597b95-6"
})(_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});
const DescriptionText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-5f597b95-7"
})(_templateObject7());
const TitleAndIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f597b95-8"
})(_templateObject8());
const IconContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f597b95-9"
})(_templateObject9());
const AlertIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_components_icons__WEBPACK_IMPORTED_MODULE_1__/* .IconAlertAlt */ .Kh).withConfig({
    componentId: "sc-5f597b95-10"
})(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.red;
});


/***/ }),

/***/ 1344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/common/Modal/Modal.styles.ts
var Modal_styles = __webpack_require__(4941);
// EXTERNAL MODULE: ./components/icons/index.js + 56 modules
var icons = __webpack_require__(2667);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
;// CONCATENATED MODULE: ./components/common/Loader.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 5rem;\n  height: 5rem;\n  animation: spin 0.5s linear infinite;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const Spinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45190e64-0"
})(_templateObject());

;// CONCATENATED MODULE: ./components/common/Loader.tsx



const Loader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Loader */.aN, {})
    });
};

// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__(8891);
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);
;// CONCATENATED MODULE: ./components/common/Modal/index.tsx






const Modal = (param)=>{
    let { children , title , onClose , withLoader , hideCloseButton , titleIcon  } = param;
    const handleCloseClick = ()=>{
        if (!onClose) return;
        onClose();
    };
    const setTitleIcon = ()=>{
        switch(titleIcon){
            case "alert":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* AlertIcon */.zM, {});
        }
    };
    let isLoaded = false;
    (0,react.useEffect)(()=>{
        if (!isLoaded) {
            isLoaded = true;
            const name = title.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr)=>chr.toUpperCase());
            mixpanel_cjs_default().track("Modal opened", {
                name
            });
        }
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, []);
    const headerContent = (0,react.useMemo)(()=>{
        if (withLoader) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_styles/* Header */.h4, {
                        children: [
                            withLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {}),
                            !hideCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* CloseButton */.PZ, {
                                onClick: handleCloseClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconClose */.bM, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* Title */.Dx, {
                        withMarginBottom: true,
                        children: title
                    })
                ]
            });
        }
        if (titleIcon) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_styles/* Header */.h4, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_styles/* TitleAndIconContainer */.TO, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* IconContainer */.qk, {
                                children: setTitleIcon()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* Title */.Dx, {
                                children: title
                            })
                        ]
                    }),
                    !hideCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* CloseButton */.PZ, {
                        onClick: handleCloseClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconClose */.bM, {})
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_styles/* Header */.h4, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* Title */.Dx, {
                    children: title
                }),
                !hideCloseButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* CloseButton */.PZ, {
                    onClick: handleCloseClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconClose */.bM, {})
                })
            ]
        });
    }, [
        withLoader,
        title,
        hideCloseButton,
        titleIcon
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* Backdrop */.YM, {
                onClick: handleCloseClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* Container */.W2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* Wrapper */.im, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_styles/* Content */.VY, {
                        children: [
                            headerContent,
                            children
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var common_Modal = (Modal);


/***/ }),

/***/ 6890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tv": function() { return /* binding */ TipWrapper; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "mo": function() { return /* binding */ InfoWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9521);
/* harmony import */ var styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5817);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: block;\n  width: 1.8rem;\n  height: 1.8rem;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  height: ",
        "px;\n  width: ",
        "px;\n  position: relative;\n  fill: ",
        ";\n  position: absolute;\n  top: -",
        "px;\n  svg {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: ",
        "px;\n  padding: 2rem;\n  background-color: ",
        ";\n  color: ",
        ";\n  white-space: normal;\n  font-size: 1.4rem;\n  font-weight: 300;\n  width: ",
        "px;\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  z-index: 2;\n  p:last-child {\n    margin-bottom: 0;\n  }\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: inline-block;\n  margin: 0 0 0 3px;\n  top: 4px;\n  ",
        "\n  @media (max-width: ",
        ") {\n    ",
        " {\n      left: -",
        "px;\n      right: auto;\n    }\n    ",
        " {\n      left: ",
        "px;\n      right: auto;\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}


const wrapperWidth = 268;
const tipWidth = 40;
const tipHeight = tipWidth / 2.5;
const borderRadius = styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .archimedesTheme.borderRadius.main */ .P.borderRadius.main;
const InfoWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df7418f4-0"
})(_templateObject());
const TipWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df7418f4-1"
})(_templateObject1(), tipHeight, tipWidth, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, tipHeight);
const Content = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df7418f4-2"
})(_templateObject2(), tipHeight + 14, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, wrapperWidth, borderRadius, (param)=>{
    let { theme  } = param;
    return theme.boxShadow.blue;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
});
const Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df7418f4-3"
})(_templateObject3(), (param)=>{
    let { position  } = param;
    switch(position){
        case "left":
            return "\n            ".concat(Content, " {\n                left: -").concat(tipWidth - 10, "px;\n            }\n            ").concat(TipWrapper, " {\n                left: ").concat(tipWidth / 2, "px;\n            }\n          ");
        case "right":
            return "\n            ".concat(Content, " {\n                right: -").concat(tipWidth - 10, "px;\n            }\n            ").concat(TipWrapper, " {\n                right: ").concat(tipWidth / 2, "px;\n            }\n          ");
        case "center":
            return "\n        ".concat(Content, " {\n            left: -").concat(wrapperWidth / 2, "px;\n        }\n        ").concat(TipWrapper, " {\n            left: ").concat(wrapperWidth / 2 - tipWidth / 2 + 10, "px;\n        }\n      ");
    }
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
}, Content, wrapperWidth / 2, TipWrapper, wrapperWidth / 2 - tipWidth / 2 + 10);


/***/ }),

/***/ 5191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Tooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2667);
/* harmony import */ var _Tooltip_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6890);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8891);
/* harmony import */ var mixpanel_browser__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(mixpanel_browser__WEBPACK_IMPORTED_MODULE_4__);





function Tooltip(param) {
    let { name , position , children  } = param;
    const [isShown, setIsShown] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Tooltip_styles__WEBPACK_IMPORTED_MODULE_2__/* .Wrapper */ .im, {
        position: "".concat(position),
        isShown: "".concat(isShown),
        onMouseEnter: ()=>{
            setIsShown(true);
            if (!name) return;
            mixpanel_browser__WEBPACK_IMPORTED_MODULE_4___default().track("TooltipShown", {
                name
            });
        },
        onMouseLeave: ()=>setIsShown(false),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip_styles__WEBPACK_IMPORTED_MODULE_2__/* .InfoWrapper */ .mo, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_1__/* .IconInfo */ .aU, {})
            }),
            isShown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Tooltip_styles__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Tooltip_styles__WEBPACK_IMPORTED_MODULE_2__/* .TipWrapper */ .Tv, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons__WEBPACK_IMPORTED_MODULE_1__/* .TooltipTip */ .ET, {})
                    }),
                    children
                ]
            })
        ]
    });
}


/***/ }),

/***/ 1322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ naturalNumber; },
/* harmony export */   "mu": function() { return /* binding */ formatLongNumber; }
/* harmony export */ });
/* unused harmony export printVaultType */
function naturalNumber(value) {
    let dec = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    let num = typeof value === "string" ? Number.parseFloat(value) : value;
    const fixedFloat = num.toFixed(dec);
    return fixedFloat.toString().replace(RegExp("\\B(?<!\\.\\d*)(?=(\\d{3})+(?!\\d))", "g"), ",");
}
function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}
/*
123.45 => 123.4
1,234.56 => 1.2k
12,345.67 => 12.3k
123,456.78 => 123.4k
anything over 999,999 => 1m+
*/ function formatLongNumber(longNum) {
    let num = typeof longNum === "string" ? Number.parseFloat(longNum) : longNum;
    let value = "";
    if (num > 1000000) {
        value = round(num / 1000000, 1).toString() + "m";
    } else if (num > 999) {
        value = round(num / 1000, 1).toString() + "k";
    } else {
        value = num.toFixed(1).toString();
    }
    return value;
}
function printVaultType(vaultId) {
    switch(vaultId){
        case 1:
            return "OUSD";
        case 99:
            return "test";
        default:
            return "Unknown";
    }
}


/***/ }),

/***/ 3093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ErrorBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/store/getters.ts
var getters = __webpack_require__(4478);
// EXTERNAL MODULE: ./components/store/index.ts + 2 modules
var store = __webpack_require__(953);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./public/icon-alert.svg
var icon_alert = __webpack_require__(8987);
// EXTERNAL MODULE: ./components/common/Typography/index.tsx + 1 modules
var Typography = __webpack_require__(990);
// EXTERNAL MODULE: ./components/common/Link/index.tsx + 1 modules
var Link = __webpack_require__(157);
;// CONCATENATED MODULE: ./public/icon-close.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M14 1.41 12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7 14 1.41Z",
    fill: "#363636"
  })));
};
/* harmony default export */ var icon_close = (SvgIconClose);
;// CONCATENATED MODULE: ./components/open-position/ErrorBox/ErrorBox.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 2rem;\n  width: 100%;\n  max-width: 516px;\n  max-height: 100%;\n  border: 2px solid ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  padding: 24px;\n  box-sizing: border-box;\n  margin-bottom: 32px;\n  display: flex;\n  @media (max-width: ",
        ") {\n    margin: auto;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  path {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: calc(100% - 24px);\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 24px);\n  padding: 0 1rem;\n  word-wrap: break-word;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-weight: 400;\n  margin-bottom: 0px;\n  line-height: 24px;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 21px;\n  color: ",
        ";\n  text-decoration: underline;\n\n  :hover {\n    opacity: 0.7;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  cursor: pointer;\n  :hover {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  height: 16px;\n  path {\n    fill: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}





const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc97a149-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.red;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.paleRed;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const StyledAlertIcon = (0,styled_components_browser_esm/* default */.ZP)(icon_alert/* default */.Z).withConfig({
    componentId: "sc-bc97a149-1"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.red;
});
const IconAndTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc97a149-2"
})(_templateObject2());
const TitleAndMessageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc97a149-3"
})(_templateObject3());
const ErrorTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-bc97a149-4"
})(_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.fonts.archivo;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.red;
});
const ErrorMessage = (0,styled_components_browser_esm/* default */.ZP)(ErrorTitle).withConfig({
    componentId: "sc-bc97a149-5"
})(_templateObject5());
const ErrorMessageLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-bc97a149-6"
})(_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.fonts.archivo;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.red;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.red;
});
const CloseIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bc97a149-7"
})(_templateObject7());
const StyledCloseIcon = (0,styled_components_browser_esm/* default */.ZP)(icon_close).withConfig({
    componentId: "sc-bc97a149-8"
})(_templateObject8(), (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.red;
});

;// CONCATENATED MODULE: ./components/open-position/ErrorBox/index.tsx





function ErrorBox(param) {
    let { className , hideCloseButton  } = param;
    const [message, setMessage] = (0,react.useState)(false);
    const [showError, setShowError] = (0,react.useState)(true);
    const error = (0,getters/* useCurrentError */.IG)();
    const formatError = ()=>{
        var _error_error, _error_error1, _error_error_data;
        if ((error === null || error === void 0 ? void 0 : error.error) == undefined && (error === null || error === void 0 ? void 0 : error.message) != undefined) {
            setMessage(error.message);
        } else if ((error === null || error === void 0 ? void 0 : error.error) != undefined && (error === null || error === void 0 ? void 0 : (_error_error = error.error) === null || _error_error === void 0 ? void 0 : _error_error.data) != undefined && (error === null || error === void 0 ? void 0 : (_error_error1 = error.error) === null || _error_error1 === void 0 ? void 0 : (_error_error_data = _error_error1.data) === null || _error_error_data === void 0 ? void 0 : _error_error_data.message) != undefined) {
            // Error from Smart Contract
            const message = error.error.data.message.replace("VM Exception while processing transaction: reverted with reason string", "");
            setMessage(message);
        }
    };
    const closeError = ()=>{
        setShowError(false);
        store/* dappStore.setState */.Rt.setState({
            currentError: false
        });
    };
    (0,react.useEffect)(()=>{
        setShowError(!!error);
        if (error) formatError();
    }, [
        error
    ]);
    const errorMessage = (0,react.useMemo)(()=>{
        var _error_title;
        if (error === null || error === void 0 ? void 0 : (_error_title = error.title) === null || _error_title === void 0 ? void 0 : _error_title.includes("leverage")) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorMessage, {
                type: "span",
                children: [
                    "Follow us on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessageLink, {
                        href: "https://twitter.com/ArchimedesFi",
                        target: "_blank",
                        children: "Twitter"
                    }),
                    " ",
                    "and",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessageLink, {
                        href: "https://discord.gg/ehYcrTkb",
                        target: "_blank",
                        children: "Discord"
                    }),
                    " ",
                    "for announcements on leverage availability."
                ]
            });
        }
        return error === null || error === void 0 ? void 0 : error.message;
    }, [
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: message && showError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            className: className,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconAndTitleContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAlertIcon, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleAndMessageContainer, {
                            children: [
                                (error === null || error === void 0 ? void 0 : error.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitle, {
                                    type: "h3",
                                    children: error === null || error === void 0 ? void 0 : error.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, {
                                    type: "span",
                                    children: errorMessage
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconContainer, {
                    onClick: closeError,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseIcon, {})
                })
            ]
        })
    });
}


/***/ }),

/***/ 9441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ useModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/store/index.ts + 2 modules
var store = __webpack_require__(953);
// EXTERNAL MODULE: ./components/common/Button/index.tsx + 1 modules
var Button = __webpack_require__(4918);
;// CONCATENATED MODULE: ./components/common/modals/CloseConfirmationModal.tsx




function CloseConfirmationModal() {
    const close = ()=>{
        store/* dappStore.setState */.Rt.setState({
            isCloseConfirmationModal: false
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Your position has been closed. Proceeds from this position are now in your wallet."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/open-position",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: close,
                        children: "Open Another Position"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/store/getters.ts
var getters = __webpack_require__(4478);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/eth/Utils.ts
var Utils = __webpack_require__(1322);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./utils/createOpenseaURL.ts

const createOpenseaURL = (positionId)=>{
    const addresses = store/* dappStore.getState */.Rt.getState().addresses;
    return "https://opensea.io/assets/ethereum/" + addresses.positionTokenAddress + "/" + positionId;
};

// EXTERNAL MODULE: ./hooks/useWeb3Methods.ts + 11 modules
var useWeb3Methods = __webpack_require__(3341);
// EXTERNAL MODULE: ./components/common/Link/index.tsx + 1 modules
var Link = __webpack_require__(157);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__(8891);
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./components/open-position/ErrorBox/index.tsx + 2 modules
var ErrorBox = __webpack_require__(3093);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/common/Modal/Modal.styles.ts
var Modal_styles = __webpack_require__(4941);
;// CONCATENATED MODULE: ./components/common/modals/ClosePositionModal.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  table {\n    width: 100%;\n  }\n  th,\n  td {\n    text-align: left;\n    width: 16%;\n    padding: 1rem 0;\n  }\n  th:last-child,\n  td:last-child {\n    text-align: left;\n    width: 20%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 6rem;\n  display: flex;\n  width: fit-content;\n  margin: 0 auto;\n  justify-content: space-between;\n  a,\n  button {\n    margin: 0 20px;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 64px;\n  height: 40px;\n  max-width: none;\n  padding: 5px 25px 5px 5px;\n  margin-top: 12px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  strong {\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}



const TableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e905bd9-0"
})(_templateObject());
const ActionsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6e905bd9-1"
})(_templateObject1());
const StyledErrorBox = (0,styled_components_browser_esm/* default */.ZP)(ErrorBox/* default */.Z).withConfig({
    componentId: "sc-6e905bd9-2"
})(_templateObject2());
const StyledDescriptionText = (0,styled_components_browser_esm/* default */.ZP)(Modal_styles/* DescriptionText */.RQ).withConfig({
    componentId: "sc-6e905bd9-3"
})(_templateObject3(), (param)=>{
    let { removeMargin  } = param;
    return removeMargin && "margin-bottom: 0px;";
});

// EXTERNAL MODULE: ./utils/toBigNumber.ts
var toBigNumber = __webpack_require__(709);
// EXTERNAL MODULE: ./utils/parseError.ts
var parseError = __webpack_require__(2466);
// EXTERNAL MODULE: ./utils/roundNumber.ts
var roundNumber = __webpack_require__(2973);
;// CONCATENATED MODULE: ./components/common/modals/ClosePositionModal.tsx















function ClosePositionModal(param) {
    let { activePosition  } = param;
    const close = ()=>{
        store/* dappStore.setState */.Rt.setState({
            isClosePositionModal: false
        });
    };
    const [pending, setPending] = (0,react.useState)(false);
    const provider = (0,getters/* useProvider */.yL)();
    const nftID = (0,getters/* useActivePositionId */.oT)();
    const contracts = (0,getters/* useContracts */.GP)();
    const currentError = (0,getters/* useCurrentError */.IG)();
    const { updateUserBalances , updateApprovalStatus  } = (0,useWeb3Methods/* useWeb3Methods */.q)();
    const closePosition = async ()=>{
        setPending(true);
        // console.log('Closing position ' + nftID);
        try {
            const collateralBigNumber = (0,toBigNumber/* toBigNumber */.O)(Number(activePosition.collateral), 18);
            const minimumOusdReturned = collateralBigNumber.mul(90).div(100);
            const tx = await contracts.levEngine.unwindLeveragedPosition(nftID, minimumOusdReturned);
            store/* dappStore.setState */.Rt.setState({
                isClosePositionModal: false
            });
            store/* dappStore.setState */.Rt.setState({
                isClosingPositionModal: true
            });
            provider.once(tx.hash, async (transaction)=>{
                // Emitted when the transaction has been mined
                // We dont want to show the processing modal for 1 second and then close it
                // It can be too jaring
                // So we artificially delay /set a minimum show time of 2 seconds
                // console.log('Transaction mined! ', transaction);
                await updateUserBalances();
                await updateApprovalStatus();
                mixpanel_cjs_default().track("PositionClosed", {
                    nftid: nftID
                });
                setTimeout(()=>{
                    setPending(false);
                    store/* dappStore.setState */.Rt.setState({
                        isClosingPositionModal: false
                    });
                    store/* dappStore.setState */.Rt.setState({
                        isCloseConfirmationModal: true
                    });
                    store/* dappStore.setState */.Rt.setState({
                        activePositionId: null
                    });
                }, 2000);
            });
        } catch (error) {
            var _error_error, _error_error_data, _error_reason;
            console.error(error);
            const message = error === null || error === void 0 ? void 0 : (_error_error = error.error) === null || _error_error === void 0 ? void 0 : (_error_error_data = _error_error.data) === null || _error_error_data === void 0 ? void 0 : _error_error_data.message;
            if (error === null || error === void 0 ? void 0 : (_error_reason = error.reason) === null || _error_reason === void 0 ? void 0 : _error_reason.includes("rejected transaction")) {
                store/* dappStore.setState */.Rt.setState({
                    currentError: {
                        message: "Transaction rejected by user."
                    }
                });
            } else {
                store/* dappStore.setState */.Rt.setState({
                    currentError: (0,parseError/* parseError */.n)(error)
                });
            }
            if ((message === null || message === void 0 ? void 0 : message.toLowerCase().includes("Not enough OUSD for exchange")) || (message === null || message === void 0 ? void 0 : message.toLowerCase().includes("3/lv insuf eX to lvUSD"))) {
                store/* dappStore.setState */.Rt.setState({
                    showUnavailableClosingPositionModal: true,
                    isClosePositionModal: false,
                    activePositionId: null
                });
            }
            setPending(false);
        }
    };
    const expiryUnix = (0,react.useMemo)(()=>{
        if (activePosition) return activePosition.unixTimestampOpened + 370 * 86400;
    }, [
        activePosition
    ]);
    const expiryDate = (0,react.useMemo)(()=>{
        if (expiryUnix) return moment_default().unix(expiryUnix).format("MMM DD, YYYY");
    }, [
        expiryUnix
    ]);
    const minimumOusdReturned = (0,react.useMemo)(()=>{
        if (activePosition === null || activePosition === void 0 ? void 0 : activePosition.collateral) {
            const collateral = Number(activePosition === null || activePosition === void 0 ? void 0 : activePosition.collateral);
            return (0,roundNumber/* roundNumber */.Q)(collateral * 0.9, 2);
        }
    }, [
        activePosition === null || activePosition === void 0 ? void 0 : activePosition.collateral
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDescriptionText, {
                removeMargin: currentError,
                children: [
                    "The total value of this position (collateral + earnings) that you will receive is expected to be a minimum of",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                        children: [
                            minimumOusdReturned,
                            " OUSD."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledErrorBox, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Opened"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Collateral"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Borrowed"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Earnings"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "Expires"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: moment_default().unix(activePosition.unixTimestampOpened).format("MMM DD, YYYY")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        children: [
                                            (0,Utils/* naturalNumber */.Rf)(activePosition.collateral),
                                            " OUSD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        children: [
                                            (0,Utils/* naturalNumber */.Rf)(activePosition.ousdBorrowed),
                                            " OUSD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: parseFloat((0,Utils/* naturalNumber */.Rf)(activePosition.totalInterestEarned)) > 0 ? (0,Utils/* naturalNumber */.Rf)(activePosition.totalInterestEarned) + " OUSD" : "--"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: expiryDate
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionsWrapper, {
                children: [
                    pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "danger",
                        disabled: true,
                        children: "Closing..."
                    }),
                    !pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "danger",
                        onClick: closePosition,
                        disabled: currentError,
                        children: "Close Position"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        variant: "outline",
                        href: createOpenseaURL(nftID),
                        target: "_blank",
                        rel: "noreferrer",
                        children: "Sell on OpenSea"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outline",
                        onClick: close,
                        children: "Nevermind"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/common/Typography/index.tsx + 1 modules
var Typography = __webpack_require__(990);
// EXTERNAL MODULE: ./components/common/Checkbox/index.tsx + 1 modules
var Checkbox = __webpack_require__(4106);
;// CONCATENATED MODULE: ./components/common/modals/LegalDisclaimerModal/LegalDisclaimerModal.styles.ts

function LegalDisclaimerModal_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 622px;\n  max-width: 100%;\n  height: calc(78vh - 15rem);\n"
    ]);
    LegalDisclaimerModal_styles_templateObject = function() {
        return data;
    };
    return data;
}
function LegalDisclaimerModal_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  height: 12rem;\n  padding-top: 2rem;\n  @media (max-width: ",
        ") {\n  }\n"
    ]);
    LegalDisclaimerModal_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function LegalDisclaimerModal_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 32px;\n  overflow-y: auto;\n  height: calc(100% - 15rem);\n\n  ",
        ";\n\n  @media (max-width: ",
        ") {\n  }\n"
    ]);
    LegalDisclaimerModal_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function LegalDisclaimerModal_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    LegalDisclaimerModal_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 3rem;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  color: ",
        ";\n  text-decoration: underline;\n  font-weight: 500;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}




/*
modal height: 90vh
top&bottom height: 10vh
title height: 5rem
actions height: 5rem
*/ const Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edfbed5c-0"
})(LegalDisclaimerModal_styles_templateObject());
const ActionsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edfbed5c-1"
})(LegalDisclaimerModal_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const TextContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edfbed5c-2"
})(LegalDisclaimerModal_styles_templateObject2(), (param)=>{
    let { showOpacity  } = param;
    return showOpacity && "\n    -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);\n    mask-image: linear-gradient(to bottom, black 50%, transparent 100%);\n  ";
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const ParagraphContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-edfbed5c-3"
})(LegalDisclaimerModal_styles_templateObject3());
const StyledCheckbox = (0,styled_components_browser_esm/* default */.ZP)(Checkbox/* default */.Z).withConfig({
    componentId: "sc-edfbed5c-4"
})(_templateObject4());
const AcceptButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-edfbed5c-5"
})(_templateObject5());
const StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-edfbed5c-6"
})(_templateObject6(), (param)=>{
    let { theme: { colors: { functional: { darkestGray  }  }  }  } = param;
    return darkestGray;
});

;// CONCATENATED MODULE: ./components/common/modals/LegalDisclaimerModal/index.tsx
/* eslint-disable react/no-unescaped-entities */ 




const LegalDisclaimerModal = ()=>{
    const [scrolledToBottom, setScrolledToBottom] = (0,react.useState)(false);
    const [checkboxChecked, setCheckboxChecked] = (0,react.useState)(false);
    function handleTextContainerScroll(event) {
        const target = event.target;
        if (target.scrollHeight - target.scrollTop === target.clientHeight) {
            setScrolledToBottom(true);
        } else {
            setScrolledToBottom(false);
        }
    }
    function handleButtonOnClick() {
        localStorage.setItem("showLegalDisclaimer", "false");
        store/* dappStore.setState */.Rt.setState({
            showLegalDisclaimerModal: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                onScroll: handleTextContainerScroll,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "p",
                            children: "This website is intended for people aged 18 and over. By using this website, you represent and warrant that you are of legal age and that you are not residing or otherwise associated with the United States of America (including its territories: American Samoa, Guam, Puerto Rico, the Northern Mariana Islands and the U.S. Virgin Islands), Cuba; Democratic People's Republic of North Korea; Islamic Republic of Iran; Syria; the Crimea and Sevastopol; the People Republic of China (excluding Hong Kong, Macao and Taiwan); ."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "p",
                            children: "This website is experimental and currently in Beta stage. Archimedes does not give any guarantees, warranties or representations, express or implied, about the accuracy, reliability, completeness or suitability of the information and materials contained in this website for any purpose."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParagraphContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "p",
                            children: "You hereby declare read, understood and agreed to Archimedes Terms of service, Privacy policy, Legal notice and Risk Disclosure Statement before using this service"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        target: "_blank",
                        href: "https://docs.archimedesfi.com/terms-of-service",
                        children: "Terms of service"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        target: "_blank",
                        href: "https://docs.archimedesfi.com/privacy-policy",
                        children: "Privacy policy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        target: "_blank",
                        href: "https://docs.archimedesfi.com/risks-disclosure-statement",
                        children: "Risk Disclosure Statement"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                        target: "_blank",
                        href: "https://docs.archimedesfi.com/legal-notice",
                        children: "Legal Notice"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCheckbox, {
                checked: checkboxChecked,
                onChange: (checked)=>setCheckboxChecked(checked),
                label: "I have read and acknowledge the legal disclaimer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AcceptButton, {
                disabled: !checkboxChecked,
                onClick: handleButtonOnClick,
                children: "Accept and Close"
            })
        ]
    });
};
/* harmony default export */ var modals_LegalDisclaimerModal = (LegalDisclaimerModal);

// EXTERNAL MODULE: ./components/icons/index.js + 56 modules
var icons = __webpack_require__(2667);
;// CONCATENATED MODULE: ./components/common/modals/ProcessingModal.tsx




function ProcessingModal() {
    const latestTx = (0,getters/* useLatestTx */.ui)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "If you close this window, your transaction will still process. Your new position will appear on your Dashboard after processing."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    href: "https://etherscan.io/tx/".concat(latestTx),
                    variant: "outline",
                    children: [
                        "View Transaction on Etherscan",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconExternal */.Ak, {})
                    ]
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/common/modals/RouteAndFeesModal.styles.ts

function RouteAndFeesModal_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    RouteAndFeesModal_styles_templateObject = function() {
        return data;
    };
    return data;
}
function RouteAndFeesModal_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 130px 250px 1fr;\n  grid-column-gap: 80px;\n  margin-top: -32px;\n  color: ",
        ";\n"
    ]);
    RouteAndFeesModal_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function RouteAndFeesModal_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  display: flex;\n  color: ",
        ";\n  justify-content: space-between;\n"
    ]);
    RouteAndFeesModal_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function RouteAndFeesModal_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: ",
        ";\n  width: 24px;\n"
    ]);
    RouteAndFeesModal_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function RouteAndFeesModal_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 23px 0;\n"
    ]);
    RouteAndFeesModal_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function RouteAndFeesModal_styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.4rem;\n  font-family: ",
        ";\n  color: ",
        ";\n"
    ]);
    RouteAndFeesModal_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function RouteAndFeesModal_styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 0.5rem;\n  font-size: 1.4rem;\n"
    ]);
    RouteAndFeesModal_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  width: 16px;\n  height: 16px;\n  background: ",
        ";\n  border-radius: 100%;\n  position: relative;\n  top: 3px;\n  margin-right: 4px;\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}

const DescriptionSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c7983905-0"
})(RouteAndFeesModal_styles_templateObject(), (param)=>{
    let { theme: { colors: { functional: { darkGray  }  }  }  } = param;
    return darkGray;
});
const DetailsGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7983905-1"
})(RouteAndFeesModal_styles_templateObject1(), (param)=>{
    let { theme: { colors: { functional: { darkGray  }  }  }  } = param;
    return darkGray;
});
const SectionTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-c7983905-2"
})(RouteAndFeesModal_styles_templateObject2(), (param)=>{
    let { theme: { fonts: { archivo  }  }  } = param;
    return archivo;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.darkestGray;
});
const ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7983905-3"
})(RouteAndFeesModal_styles_templateObject3(), (param)=>{
    let { theme: { colors: { primary: { main  }  }  }  } = param;
    return main;
});
const Group = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7983905-4"
})(RouteAndFeesModal_styles_templateObject4());
const GroupHeading = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-c7983905-5"
})(RouteAndFeesModal_styles_templateObject5(), (param)=>{
    let { theme: { fonts: { archivo  }  }  } = param;
    return archivo;
}, (param)=>{
    let { theme: { colors: { functional: { darkGray  }  }  }  } = param;
    return darkGray;
});
const Data = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c7983905-6"
})(RouteAndFeesModal_styles_templateObject6());
const CoinWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c7983905-7"
})(_templateObject7(), (param)=>{
    let { theme: { colors: { secondary: { green  }  }  }  } = param;
    return green;
});

;// CONCATENATED MODULE: ./components/common/modals/RouteAndFeesModal.tsx







function RouteAndFeesModal() {
    const provider = (0,getters/* useProvider */.yL)();
    const leverageMultiplier = (0,getters/* useLevMultiplier */.hT)();
    const originationFee = (0,getters/* useOriginationFee */.Nh)();
    const modalProps = (0,getters/* useModalProps */.C1)();
    const changeToEtherum = async ()=>{
        //TODO: changed from send to emit, check
        provider.emit("wallet_switchEthereumChain", [
            {
                chainId: "0x1"
            }
        ]);
    };
    const leverageMultiplierFormatted = (0,react.useMemo)(()=>{
        if (leverageMultiplier) return (0,roundNumber/* roundNumber */.Q)(leverageMultiplier + 1, 2);
    }, [
        leverageMultiplier
    ]);
    const originationFeePercentage = (0,react.useMemo)(()=>{
        if (originationFee) return Number(originationFee) * 100;
    }, [
        originationFee
    ]);
    const originationFeeInUsdFormatted = (0,react.useMemo)(()=>{
        if (originationFee && (modalProps === null || modalProps === void 0 ? void 0 : modalProps.estimatedPosition)) return (0,roundNumber/* roundNumber */.Q)(Number(originationFee) * (modalProps === null || modalProps === void 0 ? void 0 : modalProps.estimatedPosition), 2);
    }, [
        originationFee,
        modalProps === null || modalProps === void 0 ? void 0 : modalProps.estimatedPosition
    ]);
    const stableCoinSymbol = (0,react.useMemo)(()=>{
        if (modalProps === null || modalProps === void 0 ? void 0 : modalProps.selectedStableCoin) {
            return modalProps.selectedStableCoin.value.toUpperCase();
        }
    }, [
        modalProps === null || modalProps === void 0 ? void 0 : modalProps.selectedStableCoin
    ]);
    const stableCoinLogo = (0,react.useMemo)(()=>{
        var _modalProps_selectedStableCoin;
        // console.log({ value: modalProps?.selectedStableCoin?.value });
        switch(modalProps === null || modalProps === void 0 ? void 0 : (_modalProps_selectedStableCoin = modalProps.selectedStableCoin) === null || _modalProps_selectedStableCoin === void 0 ? void 0 : _modalProps_selectedStableCoin.value){
            case "usdc":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LogoUsdc */.Cn, {});
            case "dai":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LogoDai */._6, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LogoTether */.rm, {});
        }
    }, [
        modalProps === null || modalProps === void 0 ? void 0 : modalProps.selectedStableCoin
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* DescriptionText */.RQ, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSpan, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                        children: [
                            "The below data is an ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "estimation"
                            }),
                            " only."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DetailsGrid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                                children: [
                                    "Deposit",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupHeading, {
                                        children: "Your Deposit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Data, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinWrapper, {
                                                    children: stableCoinLogo
                                                }),
                                                modalProps === null || modalProps === void 0 ? void 0 : modalProps.deposit,
                                                " ",
                                                stableCoinSymbol
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                                children: [
                                    "Transactions & Fees",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupHeading, {
                                        children: "Leverage Fee"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Data, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinWrapper, {
                                                    children: stableCoinLogo
                                                }),
                                                modalProps === null || modalProps === void 0 ? void 0 : modalProps.tokenFeeInUsd,
                                                " ",
                                                stableCoinSymbol,
                                                " →\xa0\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinWrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LogoArch */.cB, {})
                                                }),
                                                modalProps === null || modalProps === void 0 ? void 0 : modalProps.tokenFeeInArch,
                                                " ARCH"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupHeading, {
                                        children: "Your Position Collateral"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                            children: "via Curve"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Data, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinWrapper, {
                                                    children: stableCoinLogo
                                                }),
                                                stableCoinSymbol,
                                                " →\xa0\xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinWrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LogoOusd */._4, {})
                                                }),
                                                modalProps === null || modalProps === void 0 ? void 0 : modalProps.collateral,
                                                " OUSD"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupHeading, {
                                        children: "Origination Fee"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("em", {
                                            children: [
                                                "from Collateral: ",
                                                originationFeePercentage,
                                                "% Leveraged Position"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Data, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CoinWrapper, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* LogoOusd */._4, {})
                                                }),
                                                originationFeeInUsdFormatted,
                                                " OUSD"
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                                children: [
                                    "x",
                                    leverageMultiplierFormatted,
                                    " Position (Wrapped NFT)"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupHeading, {
                                        children: "Your Leveraged Position (NFT)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Data, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "Collateral: ",
                                                    modalProps === null || modalProps === void 0 ? void 0 : modalProps.collateral,
                                                    " OUSD"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "Leverage: x",
                                                    leverageMultiplierFormatted
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "Est. Borrowed: ",
                                                    (0,roundNumber/* roundNumber */.Q)(modalProps === null || modalProps === void 0 ? void 0 : modalProps.estimatedPosition, 2),
                                                    " OUSD"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/common/modals/UnavailableClosingPositionModal/UnavailableClosingPositionModal.styles.ts

function UnavailableClosingPositionModal_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 48px;\n"
    ]);
    UnavailableClosingPositionModal_styles_templateObject = function() {
        return data;
    };
    return data;
}
function UnavailableClosingPositionModal_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    UnavailableClosingPositionModal_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function UnavailableClosingPositionModal_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 24px;\n"
    ]);
    UnavailableClosingPositionModal_styles_templateObject2 = function() {
        return data;
    };
    return data;
}



const StyledDescription = (0,styled_components_browser_esm/* default */.ZP)(Modal_styles/* DescriptionText */.RQ).withConfig({
    componentId: "sc-e612190d-0"
})(UnavailableClosingPositionModal_styles_templateObject());
const ButtonsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e612190d-1"
})(UnavailableClosingPositionModal_styles_templateObject1());
const UnavailableClosingPositionModal_styles_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-e612190d-2"
})(UnavailableClosingPositionModal_styles_templateObject2());

;// CONCATENATED MODULE: ./components/common/modals/UnavailableClosingPositionModal/UnavailableClosingPositionModal.tsx






const UnavailableClosingPositionModal = ()=>{
    const positionId = (0,getters/* useActivePositionId */.oT)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                children: "Don`t worry, your funds are safe. The Curve pools are currently out of balance, so closing a position is unavailable. Check back again later, or trade your tokenized position on OpenSea."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnavailableClosingPositionModal_styles_StyledLink, {
                        variant: "button",
                        href: "https://docs.archimedesfi.com/",
                        children: "Read documentation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UnavailableClosingPositionModal_styles_StyledLink, {
                        variant: "button",
                        href: createOpenseaURL(positionId),
                        children: "View on OpenSea"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "outline",
                        onClick: close,
                        children: "Nevermind"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var UnavailableClosingPositionModal_UnavailableClosingPositionModal = (UnavailableClosingPositionModal);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./utils/createNftImageLocation.ts

const createNftImageLocation = (positionId)=>{
    const networkID = store/* userStore.getState */.HP.getState().networkID;
    if (networkID === "1") {
        return "https://s3.us-west-2.amazonaws.com/archimedesfi-nft-images-v1.0/" + positionId + ".png";
    } else {
        return "/example-nft.png";
    }
};

;// CONCATENATED MODULE: ./components/common/modals/ViewNftModal.styles.ts

function ViewNftModal_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.4rem;\n"
    ]);
    ViewNftModal_styles_templateObject = function() {
        return data;
    };
    return data;
}
function ViewNftModal_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.4rem;\n  padding-left: 10vw;\n  display: flex;\n  align-items: flex-start;\n  img {\n    width: auto;\n    aspect-ratio: 1;\n  }\n  @media (max-width: ",
        ") {\n    padding-left: 0;\n    padding-top: 2rem;\n    img {\n      height: 100px;\n    }\n  }\n"
    ]);
    ViewNftModal_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function ViewNftModal_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  white-space: nowrap;\n  @media (max-width: ",
        ") {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    ViewNftModal_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function ViewNftModal_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: ",
        ") {\n    width: 34rem;\n  }\n"
    ]);
    ViewNftModal_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function ViewNftModal_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-family: ",
        ";\n  color: ",
        ";\n  ",
        "\n"
    ]);
    ViewNftModal_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function ViewNftModal_styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  ",
        "\n  ",
        " {\n    &:first-child {\n      width: 140px;\n    }\n  }\n\n  img {\n    object-fit: contain;\n  }\n\n  ",
        "\n"
    ]);
    ViewNftModal_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function ViewNftModal_styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: ",
        ";\n"
    ]);
    ViewNftModal_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function ViewNftModal_styles_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: ",
        ";\n  padding: 2px 3rem 2px 0;\n  border-bottom: 0;\n  &::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: calc(100% - 3rem);\n    height: 2px;\n    background: ",
        ";\n  }\n  svg {\n    position: absolute;\n    right: 0;\n  }\n"
    ]);
    ViewNftModal_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: fit-content;\n  padding: 1rem 0;\n  ",
        " {\n    margin-right: 2.4rem;\n  }\n"
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  margin-left: 10px;\n"
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}
function _templateObject10() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.4rem;\n  h4 {\n    padding: 40px 0 16px;\n  }\n  em {\n    font-style: normal;\n    color: ",
        ";\n    font-weight: 700;\n  }\n  @media (max-width: ",
        ") {\n    font-size: 1.2rem;\n  }\n"
    ]);
    _templateObject10 = function() {
        return data;
    };
    return data;
}
function _templateObject11() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject11 = function() {
        return data;
    };
    return data;
}
function _templateObject12() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 228px;\n  margin-right: 2.4rem;\n"
    ]);
    _templateObject12 = function() {
        return data;
    };
    return data;
}





const DataWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-0"
})(ViewNftModal_styles_templateObject());
const NftImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-1"
})(ViewNftModal_styles_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const NftWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-2"
})(ViewNftModal_styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-3"
})(ViewNftModal_styles_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});
const StyledSpan = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-30e481a2-4"
})(ViewNftModal_styles_templateObject4(), (param)=>{
    let { theme  } = param;
    return theme.fonts.archivo;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.darkGray;
}, (param)=>{
    let { isValue  } = param;
    return isValue && "\n    font-weight: 700;\n    width: 40%;\n    text-align: left;\n  ";
});
const StyledRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-5"
})(ViewNftModal_styles_templateObject5(), (param)=>{
    let { withMarginBottom  } = param;
    return withMarginBottom && "margin-bottom: 24px;";
}, StyledSpan, (param)=>{
    let { nftContainer  } = param;
    return nftContainer && "padding-right: 2rem;";
});
const ViewNftModal_styles_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-30e481a2-6"
})(ViewNftModal_styles_templateObject6(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});
const ExternalStyledLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-30e481a2-7"
})(ViewNftModal_styles_templateObject7(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
});
const LinksWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-8"
})(_templateObject8(), ViewNftModal_styles_StyledLink);
const StyledIconExternal = (0,styled_components_browser_esm/* default */.ZP)(icons/* IconExternal */.Ak).withConfig({
    componentId: "sc-30e481a2-9"
})(_templateObject9());
const ConfirmationWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-10"
})(_templateObject10(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const Text = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-30e481a2-11"
})(_templateObject11());
const StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-30e481a2-12"
})(_templateObject12());

;// CONCATENATED MODULE: ./components/common/modals/ViewNftModal.tsx












function ViewNftModal(param) {
    let { confirmationMode , activePosition  } = param;
    const positionId = (0,getters/* useActivePositionId */.oT)();
    const [imageSrc, setImageSrc] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        setImageSrc(createNftImageLocation(positionId));
    }, [
        positionId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            confirmationMode && renderConfirmationHeader(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NftWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DataWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            type: "span",
                                            children: "Collateral"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpan, {
                                            type: "span",
                                            isValue: true,
                                            children: [
                                                (0,Utils/* naturalNumber */.Rf)(activePosition.collateral),
                                                " USD"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            type: "span",
                                            children: "Borrowed"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpan, {
                                            type: "span",
                                            isValue: true,
                                            children: [
                                                (0,Utils/* naturalNumber */.Rf)(activePosition.ousdBorrowed),
                                                " OUSD"
                                            ]
                                        })
                                    ]
                                }),
                                !confirmationMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            type: "span",
                                            children: "Est. Net APY"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            type: "span",
                                            isValue: true,
                                            children: activePosition.apy > 0 ? (0,Utils/* naturalNumber */.Rf)(activePosition.apy.toString()) + "%" : "--"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            type: "span",
                                            children: "Position Lifetime"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpan, {
                                            type: "span",
                                            isValue: true,
                                            children: [
                                                activePosition.lifetimeInDays,
                                                " Days"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NftImageWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRow, {
                                nftContainer: true,
                                children: imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: imageSrc,
                                    width: "160",
                                    height: "160",
                                    alt: "NFT",
                                    onError: ()=>setImageSrc("/example-nft.png")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRow, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpan, {
                                            type: "span",
                                            children: "Your Tradable Position"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRow, {
                                        withMarginBottom: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpan, {
                                            type: "span",
                                            children: [
                                                "NFT ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "#",
                                                        positionId
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRow, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExternalStyledLink, {
                                            variant: "thick",
                                            href: createOpenseaURL(positionId),
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                "View on OpenSea",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconExternal, {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function renderConfirmationHeader() {
    const latestTx = store/* dappStore.getState */.Rt.getState().latestTx;
    const handleOpenAnotherPositionClick = ()=>{
        store/* dappStore.setState */.Rt.setState({
            activePositionId: null,
            activePosition: null,
            isViewNft: false
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmationWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                "Congratulations! You have opened a new position. You can now trade it on any NFT marketplace.\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: "https://docs.archimedesfi.com/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "View documentation here"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                    children: "Note:"
                                }),
                                " There was a surplus of ARCH from this transaction. We have transferred the amount to your wallet."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinksWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                            onClick: handleOpenAnotherPositionClick,
                            children: "Open Another Position"
                        }),
                        latestTx && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                href: "https://etherscan.io/tx/".concat(latestTx),
                                target: "_blank",
                                variant: "outline",
                                rel: "noreferrer",
                                children: [
                                    "View Transaction on Etherscan",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconExternal */.Ak, {})
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    children: "Your Position Details"
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/common/modals/WrongNetworkModal.tsx




function WrongNetworkModal() {
    const provider = (0,getters/* useProvider */.yL)();
    const changeToEtherum = async ()=>{
        //TODO: changed from send to emit, check
        provider.emit("wallet_switchEthereumChain", [
            {
                chainId: "0x1"
            }
        ]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_styles/* DescriptionText */.RQ, {
                children: "Archimedes only supports Ethereum. Change to the Ethereum Blockchain to continue."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: changeToEtherum,
                children: "Change to Localhost"
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./hooks/useModal.tsx













const useModal = ()=>{
    const viewNftModalOpened = (0,getters/* useIsViewNft */.FC)();
    const wrongNetworkModalOpened = (0,getters/* useIsWrongNetwork */.QL)();
    const processingModalOpened = (0,getters/* useIsProcessingModalOpen */.bj)();
    const showLegalDisclaimerModal = (0,getters/* getShowLegalDisclaimerModal */.Lc)();
    const showRouteAndFeesModal = (0,getters/* getShowIsRouteAndFeesModal */.r6)();
    const activePosition = (0,getters/* useActivePosition */.M$)();
    const closePositionModalOpened = (0,getters/* useIsClosePositionModal */.bq)();
    const closeConfimationModalOpened = (0,getters/* useIsCloseConfirmationModal */.eZ)();
    const closingPositionModalOpened = (0,getters/* useIsClosingPositionModal */.dZ)();
    const unavailableClosingPositionModalOpened = (0,getters/* useShowUnavailableClosingPositionModal */.DD)();
    const { pathname  } = (0,router.useRouter)();
    // Always check if we need to show the legal disclaimer modal
    (0,react.useEffect)(()=>{
        const showLegalDisclaimer = localStorage.getItem("showLegalDisclaimer");
        if (!showLegalDisclaimer) {
            localStorage.setItem("showLegalDisclaimer", "true");
            store/* dappStore.setState */.Rt.setState({
                showLegalDisclaimerModal: true
            });
        } else {
            store/* dappStore.setState */.Rt.setState({
                showLegalDisclaimerModal: JSON.parse(showLegalDisclaimer)
            });
        }
    }, []);
    // Render the modals
    const modalComponent = (0,react.useMemo)(()=>{
        if (showRouteAndFeesModal) return /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteAndFeesModal, {});
        if (wrongNetworkModalOpened) return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrongNetworkModal, {});
        if (showLegalDisclaimerModal) return /*#__PURE__*/ (0,jsx_runtime.jsx)(modals_LegalDisclaimerModal, {});
        if (viewNftModalOpened) {
            if (activePosition) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewNftModal, {
                confirmationMode: pathname.includes("open-position"),
                activePosition: activePosition
            });
        }
        if (processingModalOpened) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProcessingModal, {});
        if (closePositionModalOpened) {
            if (activePosition) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClosePositionModal, {
                activePosition: activePosition
            });
        }
        if (closeConfimationModalOpened) return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseConfirmationModal, {});
        if (unavailableClosingPositionModalOpened) return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnavailableClosingPositionModal_UnavailableClosingPositionModal, {});
    }, [
        processingModalOpened,
        wrongNetworkModalOpened,
        viewNftModalOpened,
        activePosition,
        showLegalDisclaimerModal,
        showRouteAndFeesModal,
        closePositionModalOpened,
        closeConfimationModalOpened,
        unavailableClosingPositionModalOpened,
        pathname
    ]);
    const modalTitle = (0,react.useMemo)(()=>{
        if (wrongNetworkModalOpened) return "Change your network";
        if (showLegalDisclaimerModal) return "Legal Disclaimer";
        if (viewNftModalOpened) {
            if (pathname.includes("open-position")) return "Confirmation";
            return "Your Position Details";
        }
        if (processingModalOpened) return "Processing Transaction";
        if (showRouteAndFeesModal) return "Route & Fee Details";
        if (closePositionModalOpened) return "Are you sure you want to close this position?";
        if (unavailableClosingPositionModalOpened) return "Sorry, closing a position is temporarily unavailable.";
        if (closingPositionModalOpened) return "Closing Position...";
        return "Confirmation";
    }, [
        processingModalOpened,
        wrongNetworkModalOpened,
        viewNftModalOpened,
        showLegalDisclaimerModal,
        showRouteAndFeesModal,
        closePositionModalOpened,
        unavailableClosingPositionModalOpened,
        closingPositionModalOpened,
        pathname
    ]);
    function closeModal() {
        if (viewNftModalOpened) {
            store/* dappStore.setState */.Rt.setState({
                isViewNft: false
            });
            return;
        }
        if (processingModalOpened) return store/* dappStore.setState */.Rt.setState({
            isProcessingModalOpen: false
        });
        if (showRouteAndFeesModal) return store/* dappStore.setState */.Rt.setState({
            showRouteAndFeesModal: false
        });
        if (closePositionModalOpened) return store/* dappStore.setState */.Rt.setState({
            isClosePositionModal: false
        });
        if (unavailableClosingPositionModalOpened) return store/* dappStore.setState */.Rt.setState({
            showUnavailableClosingPositionModal: false
        });
        if (closeConfimationModalOpened) return store/* dappStore.setState */.Rt.setState({
            isCloseConfirmationModal: false
        });
        if (unavailableClosingPositionModalOpened) return store/* dappStore.setState */.Rt.setState({
            showUnavailableClosingPositionModal: false
        });
    }
    const hideCloseButton = (0,react.useMemo)(()=>{
        return wrongNetworkModalOpened || showLegalDisclaimerModal;
    }, [
        wrongNetworkModalOpened,
        showLegalDisclaimerModal
    ]);
    const showLoader = (0,react.useMemo)(()=>{
        return processingModalOpened || closingPositionModalOpened;
    }, [
        processingModalOpened,
        closingPositionModalOpened
    ]);
    const titleIconName = (0,react.useMemo)(()=>{
        if (unavailableClosingPositionModalOpened) return "alert";
    }, [
        unavailableClosingPositionModalOpened
    ]);
    const isModalOpen = (0,react.useMemo)(()=>{
        return viewNftModalOpened && activePosition || wrongNetworkModalOpened || closePositionModalOpened && activePosition || showLegalDisclaimerModal || processingModalOpened || showRouteAndFeesModal || unavailableClosingPositionModalOpened || closeConfimationModalOpened || wrongNetworkModalOpened || closingPositionModalOpened;
    }, [
        processingModalOpened,
        wrongNetworkModalOpened,
        viewNftModalOpened,
        activePosition,
        showLegalDisclaimerModal,
        showRouteAndFeesModal,
        unavailableClosingPositionModalOpened,
        closeConfimationModalOpened,
        closingPositionModalOpened,
        closePositionModalOpened
    ]);
    return {
        modalComponent,
        modalTitle,
        closeModal,
        isModalOpen,
        hideCloseButton,
        showLoader,
        titleIconName
    };
};


/***/ }),

/***/ 2973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ roundNumber; }
/* harmony export */ });
const roundNumber = (value, decimals)=>{
    const num = Number(Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals).toFixed(decimals));
    if (!num) return 0;
    return num;
};


/***/ })

}]);